import React from 'react'
import { Box } from '@mui/material'
import { IFilterComponentProps } from 'components/Table/TableFilter/types'
import { dateFilterContainer } from '../Inputs.style'
import { Select } from '../../../../../ui'

function SelectFilterInput({
  value,
  columnId,
  handleFilterState,
  filterParams,
  startAdornment,
  handleApplyGlobalFilters,
}: IFilterComponentProps) {
  const enhancedOptions = [
    { value: '__empty__', label: 'Empty' },
    { value: '__not_empty__', label: 'Not Empty' },
    ...(filterParams?.filterOptions || []),
  ]

  return (
    <Box sx={dateFilterContainer}>
      <Box>{startAdornment}</Box>
      <Select
        options={enhancedOptions}
        value={value || ''}
        onChange={(event) => {
          handleFilterState(columnId, null, event.target.value)
          handleApplyGlobalFilters?.()
        }}
        sx={{
          backgroundColor: 'transparent',
          minWidth: 100,
        }}
        variant="standard"
      />
    </Box>
  )
}

export default SelectFilterInput
